<template>
  <div v-if="items.length" class="pickup-points-list">
    <div class="pickup-points-list_title">
      <inner-title>
        <template v-slot:title>
          Адреса самовывоза
        </template>
        <template v-slot:subtitle />
      </inner-title>
    </div>

    <div v-show="loading" class="pickup-points-list_loading">
      <loader :absolute="true" :fixed="false" />
    </div>
    <transition name="slide">
      <div v-show="!loading" class="row">
        <div
          v-for="point in items"
          :key="point.id"
          class="col-12 col-md-4"
        >
          <nuxt-link :to="`/delivery/points/${point.slug}`" tag="a" class="pickup-points-list_item">
            <div class="pickup-points-list_item_icon">
              <font-awesome-icon :icon="['fas', 'map-marker-alt']" />
            </div>
            <div class="pickup-points-list_item_content">
              <div class="pickup-points-list_item_field pickup-points-list_item_address">
                <span v-if="false" class="pickup-points-list_item_city">
                  {{ point.city }},&nbsp;
                </span>
                {{ point.address }}
              </div>
              <div v-if="point.startTime && point.endTime" class="pickup-points-list_item_field pickup-points-list_item_time">
                с {{ point.startTime }} до {{ point.endTime }}
              </div>
              <div v-if="point.metro" class="pickup-points-list_item_field pickup-points-list_item_metro">
                {{ point.metro }}
              </div>
              <div v-if="point.workPhone" class="pickup-points-list_item_field pickup-points-list_item_phone">
                {{ point.workPhone }}
              </div>
            </div>
          </nuxt-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import InnerTitle from '~/components/UI/InnerTitle'
import Loader from '~/components/UI/PageLoader'
export default {
  name: 'PickupPointsList',
  components: { Loader, InnerTitle },
  data () {
    return {
      items: [],
      loading: true,
    }
  },
  async fetch () {
    this.loading = true
    try {
      this.items = await this.$store.dispatch('info/fetchPickupPoints')
    } catch (e) {
      console.error(e)
    }
    this.loading = false
  },
}
</script>

<style lang="less" scoped>
  .pickup-points-list {
    margin-bottom: 50px;

    &_title {
      margin-bottom: 40px;
    }

    &_loading {
      height: 100px;
      position: relative;
    }

    &_item {
      width: 100%;
      height: 125px;
      display: flex;
      justify-content: stretch;
      align-items: center;
      flex-grow: 1;
      flex-shrink: 0;
      background-color: white;
      padding: 20px;
      border-radius: 15px;
      box-shadow: 0 3px 36px rgba(122, 122, 122, 0.16);
      margin-bottom: 24px;
      color: #000;
      text-decoration: none;

      &_icon {
        color: #E31E24;
        font-size: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 15px;
      }

      &_content {
        display: flex;
        flex-direction: column;
      }

      &_field {
        //text-align: right;
        font-weight: 300;
        font-family: 'Roboto Slab', Arial, sans-serif;
        font-size: 14px;

        &:not(:last-child) {
          margin-bottom: 7px;
        }
      }

      &_address {
        font-weight: 500;
        line-height: 1.2;
        font-size: 14px;
      }

      &_metro {
        color: #919191;
      }

      &_phone {
        font-weight: 500;
        font-size: 15px;
      }

      &_city {
        color: #7c7c7c;
        font-weight: normal;
      }
    }
  }
</style>
